// extracted by mini-css-extract-plugin
export var content = "_67-3";
export var list = "_67-4";
export var settingsContent = "_67-7";
export var settingsPanel = "_67-8";
export var state = "_67-6";
export var triggerBadge = "_67-2";
export var triggerButton = "_67-1";
export var triggerShell = "_67-0";
export var unreadDot = "_67-5";